import {
    INIT_COMPANY_ADMIN_LIST_REQUEST,
    SET_COMPANY_ADMIN_LIST,
    ERROR_COMPANY_ADMIN_LIST,
    INIT_SINGLE_ADMIN_REQUEST,
    SET_SINGLE_ADMIN,
    ERROR_SINGLE_ADMIN
} from './action';

const initialState = {
    isLoading: false,
    companyAdminList: [],
    singleAdmin: null,
    singleAdminLoading: false,
    singleAdminError: null,
    error: null
};

const companyAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_COMPANY_ADMIN_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case SET_COMPANY_ADMIN_LIST:
            return {
                ...state,
                isLoading: false,
                companyAdminList: action.payload,
                error: null
            };
        case ERROR_COMPANY_ADMIN_LIST:
            return {
                ...state,
                isLoading: false,
                companyAdminList: [],
                error: action.payload
            };
        case INIT_SINGLE_ADMIN_REQUEST:
            return {
                ...state,
                singleAdminLoading: true,
                singleAdminError: null,
                singleAdmin: null
            };
        case SET_SINGLE_ADMIN:
            return {
                ...state,
                singleAdminLoading: false,
                singleAdmin: action.payload,
                singleAdminError: null
            };
        case ERROR_SINGLE_ADMIN:
            return {
                ...state,
                singleAdminLoading: false,
                singleAdmin: null,
                singleAdminError: action.payload
            };
        default:
            return state;
    }
};

export default companyAdminReducer;
